// Every dollar figure on the site goes through here so grouping and cents are
// Intl's job, not hand-built `$${n}` strings.
//   formatUSD(n)     "$25", "$25.50", "$1,200"  (cents only when there are any)
//   formatUSD(n, 2)  "$25.00"                  (money that moves: totals, fees, escrow)
//   formatUSD(n, 0)  "$25"                     (rounded: prices, charts, budgets)
const base = { style: 'currency', currency: 'USD' };
const formats = {
  auto: new Intl.NumberFormat('en-US', { ...base, minimumFractionDigits: 2, maximumFractionDigits: 2, trailingZeroDisplay: 'stripIfInteger' }),
  2: new Intl.NumberFormat('en-US', { ...base, minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  0: new Intl.NumberFormat('en-US', { ...base, minimumFractionDigits: 0, maximumFractionDigits: 0 }),
};

export function formatUSD(n, decimals = 'auto') {
  return (formats[decimals] || formats.auto).format(Number(n) || 0);
}

// A dispute an admin resolved as a SPLIT paid the seller part and refunded the
// buyer the rest, but it still leaves status 'completed' and escrowStatus
// 'released' — so every label that reads freelancerPayout/totalCharged
// described a full payout, on both sides, including the archive totals.
//
// Returns null for anything that isn't a split (a full release or refund is
// already described correctly by those fields), otherwise the amounts
// resolveReview recorded (services/escrowLifecycle.js). Works on an Order or a
// Contract — the review sub-document is the same shape on both.
//
// ponytail: documents resolved before paidOut/refunded were stored fall back to
// splitPct, which ignores the postage pass-through — close enough for a label
// on an old order, and exact for everything resolved from now on.
export function splitSettlement(doc) {
  const r = doc?.review?.resolution;
  if (r?.type !== 'split') return null;
  const pct = Number(r.splitPct) || 0;
  return {
    splitPct: pct,
    paidOut: r.paidOut != null
      ? Number(r.paidOut)
      : (Number(doc.freelancerPayout) || 0) * (1 - pct / 100),
    refunded: r.refunded != null
      ? Number(r.refunded)
      : (Number(doc.totalCharged) || 0) * (pct / 100),
  };
}

// What the viewer's side of a split actually came to: banked, for a seller;
// kept by the other side after their refund, for a buyer.
export function splitAmountFor(doc, isSeller) {
  const s = splitSettlement(doc);
  if (!s) return null;
  return isSeller ? s.paidOut : (Number(doc.totalCharged) || 0) - s.refunded;
}
